import axios, { AxiosError } from "axios";
import { Action, Dispatch } from "redux";
import { setNotificationOpen } from "../../components/Notification/redux/Slice";
import { createNotificationObject } from "../../components/Notification/Scripts";
import { notificationType } from "../../components/Notification/redux/Types";
import { JsonApiDocument } from "../../common/ApiSchemaType/Types";
import { IHeaderType, IRequest, IErrorData } from "./Types";

/**
 * Return header type
 * update default header option, if cmonig from request
 */
export const getheader = (requestHeader: IRequest): IHeaderType => {
  const DefaultHeader = {
    "Content-Type": "application/vnd.api+json"
  };
  if (requestHeader.header) {
    Object.keys(requestHeader.header).forEach((Key: string) => {
      if (requestHeader.header && requestHeader.header[Key]) {
        DefaultHeader[Key] = requestHeader.header[Key];
      }
    });
  }
  return {
    headers: DefaultHeader
  };
};

/**
 * Return API URL
 * combine relative and endpoint
 */
export const getUrl = (url: IRequest): string => {
  if (url.preSignUrl) {
    return url.preSignUrl;
  }
  const endPoint = url.endPoint
    ? url.endPoint
    : process.env.APP_EXTRACT_SERVICE_API;
  return endPoint + url.relativeUrl;
};

/**
 * Return API success response
 * Log reponse in string format
 */
export const setSuccesResponse = (response: JsonApiDocument): JsonApiDocument => {
  return response;
};

/**
 * Return API error response
 * Log reponse in string format
 */
export const setErrorResponse = (error: AxiosError): IErrorData => {
  if (axios.isAxiosError(error) && error.response) {
    return error.response.data;
  } else {
    return error.message;
  }
};

/**
 * Mock unauthorized error object
 */
export const error: IErrorData = {
  errors: [
    {
      status: "401",
    }
  ]
};

/**
 * Set unauthorized notification
 */
export const setUnauthorizedMessage = (dispatch: Dispatch<Action>): void => {
  const notification = createNotificationObject(
    "auth-failed",
    "Session expired. Please Login to continue",
    "error",
    3000);
  dispatch(setNotificationOpen(notification));
};

/**
 * Set notification details
 */
export const setNotification = (
  dispatch: Dispatch<Action>,
  id: string,
  text: string,
  type: notificationType
): void => {
  const notification = createNotificationObject(id, text, type);
  dispatch(setNotificationOpen(notification));
};
